import "./errors.scss";

interface ErrorsProps {
  errors: { [key: string]: string[] } | null;
  isWarning?: boolean;
  messageToIgnore?: string;
}

const Errors: React.FC<ErrorsProps> = ({ errors, isWarning, messageToIgnore }) => {
  // if errors only contains messageToIgnore then return null
  if (errors && Object.keys(errors).length === 1 && Object.values(errors)[0].length === 1 && Object.values(errors)[0][0] === messageToIgnore) {
    return null;
  }
  return (
    <>
      {errors && Object.keys(errors).length > 0 && (
        <div className="content">
          <ul className={`notification ${isWarning ? "is-warning" : "is-danger"}`}>
            {Object.keys(errors).map((field, i) => {
              return errors[field].map((error, j) => {
                if (!messageToIgnore || error != messageToIgnore) {
                  return <li key={i + "" + j}>{error}</li>;
                }
              });
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default Errors;
